import { __awaiter, __decorate, __metadata } from "tslib";
import { userSettingsStore } from '@/store/store';
import { isoDate } from '@/util/date-helper';
import { Module, Mutation, MutationAction, VuexModule } from 'vuex-module-decorators';
export const filterStoreModuleName = 'filterStore';
let FilterModule = class FilterModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.period = {
            endDate: '',
            startDate: '',
        };
        this.resources = [];
    }
    initializeFilterPeriod() {
        return __awaiter(this, void 0, void 0, function* () {
            const startDate = isoDate(userSettingsStore.timezone, 6);
            const endDate = isoDate(userSettingsStore.timezone);
            return { period: { endDate, startDate } };
        });
    }
    setPeriod(period) {
        if (period.startDate) {
            this.period.startDate = period.startDate;
        }
        if (period.endDate) {
            this.period.endDate = period.endDate;
        }
    }
    setResource(resources) {
        this.resources = [...resources];
    }
};
__decorate([
    MutationAction,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], FilterModule.prototype, "initializeFilterPeriod", null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], FilterModule.prototype, "setPeriod", null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], FilterModule.prototype, "setResource", null);
FilterModule = __decorate([
    Module({
        name: filterStoreModuleName,
        namespaced: true,
        stateFactory: true,
    })
], FilterModule);
export { FilterModule };
